import {Container, ContainerEntity} from "../../../model/container";
import {contains} from "../../../util/util";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {CargoSubtype} from "../../../model/cargo-subtype";

export type ContainerSelectorProps = {
  regionId?: string
  siteId?: string;
  cargoSubtype?: CargoSubtype;
  showDoNotUse?: boolean;
  containerClusterId?: string;
};

const getRegionIdParam = createParamSelector<ContainerSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getSiteIdParam = createParamSelector<ContainerSelectorProps | undefined, string | undefined>(params => params?.siteId);
const getCargoSubtypeParam = createParamSelector<ContainerSelectorProps | undefined, CargoSubtype | undefined>(params => params?.cargoSubtype);
const getShowDoNotUseParam = createParamSelector<ContainerSelectorProps | undefined, boolean | undefined>(params => params?.showDoNotUse);
const getContainerClusterIdParam = createParamSelector<ContainerSelectorProps | undefined, string | undefined>(params => params?.containerClusterId);

export const containerSelector = () => createSelector(
  [getUseQueryResultData<Container>],
  (data) => {
    return data ? transformContainer(data) : undefined;
  }
);

export const containersSelector = () => createSelector(
  [
    getUseQueryResultData<Container[]>,
    getRegionIdParam,
    getSiteIdParam,
    getCargoSubtypeParam,
    getShowDoNotUseParam,
    getContainerClusterIdParam
  ],
  (data, regionId, siteId, cargoSubtype, showDoNotUse, containerClusterId) => {
    return selectContainersAndTransform(
      data ?? [], {
        regionId: regionId,
        siteId: siteId,
        cargoSubtype: cargoSubtype,
        showDoNotUse: showDoNotUse,
        containerClusterId: containerClusterId,
      }
    );
  }
);

export const transformContainer = (value: Container): ContainerEntity => {
  return ContainerEntity.from(value)
}

export const selectContainers = (values?: Container[], selector?: ContainerSelectorProps): Container[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (!contains(v.regionList, id => id === selector.regionId)) {
        filterIn = false;
      }
    }

    if (selector?.siteId) {
      if (selector.siteId !== v.siteId) {
        filterIn = false;
      }
    }

    if (selector?.containerClusterId) {
      if (selector.containerClusterId !== v.containerClusterId) {
        filterIn = false;
      }
    }

    if (selector?.cargoSubtype) {
      if (selector.cargoSubtype.code !== v.waterTypeCargoSubtype) {
        filterIn = false;
      }
    }

    if (filterIn && typeof selector?.showDoNotUse !== "undefined" && !selector.showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const selectContainersAndTransform = (values?: Container[], selector?: ContainerSelectorProps): ContainerEntity[] => {
  const selected = selectContainers(values, selector);
  return selected.map(transformContainer);
};
